import { useEffect, useState } from "react";
import { onToast, ToastItem } from "../lib/toast";
import { IconCheck } from "./Icons";

const TTL_MS = 6000;

export default function ToastHost() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => {
    const timers = new Map<number, ReturnType<typeof setTimeout>>();
    const off = onToast((t) => {
      setItems((prev) => [...prev, t]);
      timers.set(t.id, setTimeout(() => {
        setItems((prev) => prev.filter((i) => i.id !== t.id));
        timers.delete(t.id);
      }, TTL_MS));
    });
    return () => {
      off();
      timers.forEach(clearTimeout);
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="toast-host">
      {items.map((t) => (
        <div
          key={t.id}
          className={`toast toast-${t.type}`}
          onClick={() => setItems((prev) => prev.filter((i) => i.id !== t.id))}
        >
          {t.type === "ok" ? <IconCheck size={16} /> : <span>⚠</span>}
          <span>{t.text}</span>
        </div>
      ))}
    </div>
  );
}
